let isloggedIn = false;

function recolorSeatingPlan(seatmap)
{
  isloggedIn = window.dataLayer?.filter(item => item.session)?.pop()?.session?.modeOfSale || 3;

  const seatmapSVG = document.querySelector('.tn-syos-seat-map__svg')
  // Aligning the ids with the names that are already used by tnew
  const seatSymbolPrefix = 'tn-syos-seat-map-icon-circle-'
  const starSeatSymbolSuffix = '-b-star'
  const colors = [
    '#111111', // Off Black
    '#e30613', // SW Red
    '#2E7271', // Teal
    '#880E4f', // Aubergine
    '#FFB3E8', // Light Pink
    '#5BDFD1', // Cool Blue/Green
    '#EF7B4A', // Orange
  ]
  const accessColor = '#808000'
  const letters = [
    'a', // A - Off Black
    'b', // B - SW Red
    'c', // C - Teal
    'd', // D - Aubergine
    'e', // E - Light Pink
    'f', // F - Cool Blue/Green
    'g', // G - Orange
  ]
  const paths = {
    'a': 'M34.439 26.58L43.636 55h-5.717l-2.155-6.711h-9.777L23.833 55h-5.469l9.28-28.42h6.795zm-3.315 4.806h-.414l-1.823 7.208-1.906 5.552h7.789l-1.906-5.552-1.74-7.208z',
    'b': 'M32.911 26.829c2.983 0 5.22.649 6.712 1.947 1.491 1.298 2.237 3.08 2.237 5.344 0 3.204-1.768 5.248-5.303 6.131v.415c2.044.442 3.618 1.201 4.723 2.278s1.657 2.527 1.657 4.35c0 2.376-.787 4.254-2.361 5.635C39 54.309 36.723 55 33.74 55H21.063V26.829H32.91zm-.165 16.074h-6.049v7.457h6.38c1.27 0 2.293-.29 3.066-.87.773-.58 1.16-1.533 1.16-2.859 0-2.485-1.52-3.728-4.557-3.728zm-.249-11.434h-5.8v6.794h5.8c2.652 0 3.977-1.133 3.977-3.397 0-2.265-1.325-3.397-3.977-3.397z',
    'c': 'M31.657 55.5c-2.375 0-4.377-.373-6.007-1.119-1.63-.745-2.955-1.767-3.977-3.065-1.022-1.298-1.754-2.831-2.196-4.599-.442-1.767-.663-3.673-.663-5.717 0-1.989.221-3.867.663-5.634.442-1.768 1.174-3.315 2.196-4.64 1.022-1.326 2.347-2.362 3.977-3.107 1.63-.746 3.632-1.119 6.007-1.119 3.204 0 6.38.718 9.529 2.154l-1.077 4.309c-2.928-1.215-5.552-1.823-7.872-1.823-2.817 0-4.82.898-6.007 2.693-1.188 1.795-1.781 4.184-1.781 7.167 0 2.983.593 5.372 1.781 7.167s3.19 2.693 6.007 2.693c2.265 0 4.889-.58 7.872-1.74l1.077 4.226c-3.149 1.436-6.325 2.154-9.529 2.154z',
    'd': 'M31.289 26.829c2.265 0 4.184.359 5.758 1.077 1.575.718 2.859 1.698 3.853 2.941.995 1.243 1.726 2.72 2.196 4.433.47 1.712.704 3.563.704 5.551 0 1.989-.235 3.853-.704 5.593-.47 1.74-1.201 3.246-2.196 4.516-.994 1.27-2.278 2.265-3.853 2.983C35.473 54.64 33.554 55 31.29 55H20.932V26.829h10.357zm0 4.64h-4.972V50.36h4.972c2.54 0 4.322-.87 5.344-2.61 1.022-1.74 1.533-4.046 1.533-6.919 0-2.872-.511-5.15-1.533-6.835-1.022-1.685-2.803-2.527-5.344-2.527z',
    'e': 'M40.57 55H21.43V26.829h18.974v4.64h-13.34v6.628h11.435v4.64H27.064v7.623H40.57z',
    'f': 'M27.479 55h-5.635V26.829h18.312v4.64H27.479v7.457H38.25v4.64H27.479z',
    'g': 'M31 55.5c-2.375 0-4.378-.373-6.007-1.119-1.63-.745-2.955-1.767-3.977-3.065-1.022-1.298-1.754-2.831-2.196-4.599-.442-1.767-.663-3.673-.663-5.717 0-1.989.221-3.867.663-5.634.442-1.768 1.174-3.315 2.196-4.64 1.022-1.326 2.347-2.362 3.977-3.107 1.63-.746 3.632-1.119 6.007-1.119 3.204 0 6.38.718 9.529 2.154l-1.078 4.309c-2.927-1.215-5.551-1.823-7.871-1.823-2.817 0-4.82.898-6.007 2.693-1.188 1.795-1.782 4.184-1.782 7.167 0 2.983.608 5.372 1.823 7.167 1.216 1.795 3.038 2.693 5.469 2.693.552 0 1.132-.028 1.74-.083.607-.055 1.298-.22 2.071-.497v-9.197h5.635v12.263C37.38 54.782 34.204 55.5 31 55.5z',
    'h': 'M25.49 55.086h-5.634V26.914h5.634v11.269h11.02V26.914h5.634v28.172H36.51V42.823H25.49z',
    'i': 'M33.75 55.086h-5.634V26.914h5.634z',
    'w': 'M26.07 55h-6.629l-7.208-28.42h5.717l3.231 12.926 1.74 9.031h.415l1.574-9.031 3.149-12.926h6.131l3.314 12.926 1.575 9.031h.414l1.574-9.031 3.232-12.926h5.468L42.559 55H35.93l-3.48-12.677-1.326-6.546h-.414l-1.243 6.546z',
    'wc': 'M31.657 55.5c-2.375 0-4.377-.373-6.007-1.119-1.63-.745-2.955-1.767-3.977-3.065-1.022-1.298-1.754-2.831-2.196-4.599-.442-1.767-.663-3.673-.663-5.717 0-1.989.221-3.867.663-5.634.442-1.768 1.174-3.315 2.196-4.64 1.022-1.326 2.347-2.362 3.977-3.107 1.63-.746 3.632-1.119 6.007-1.119 3.204 0 6.38.718 9.529 2.154l-1.077 4.309c-2.928-1.215-5.552-1.823-7.872-1.823-2.817 0-4.82.898-6.007 2.693-1.188 1.795-1.781 4.184-1.781 7.167 0 2.983.593 5.372 1.781 7.167s3.19 2.693 6.007 2.693c2.265 0 4.889-.58 7.872-1.74l1.077 4.226c-3.149 1.436-6.325 2.154-9.529 2.154z'
  }

  // Barclays Dance Pass Specific Variables
  let barclaysDancePassZoneID = null;
  const barclaysBlue = '#009ee3';
  const BARCLAYS_LABEL = /barclays/i;

  /*
  * This function generates the symbols that need to be displayed on the seatmap
  * The seats then reference the symbols though a <use> element
  *
  * Expected output
  * <symbol id="tn-syos-seat-map-icon-circle-A">
  *   <circle cx="31" cy="41" r="29"></circle>
  *   <path fill="#FFF" d="M27.479 55h-5.635V26.829h18.312v4.64H27.479v7.457H38.25v4.64H27.479z"></path>
  * </symbol>
  *
  * @param letter (string) - The letter to be displayed inside the icon. Should correspond to appt path in the paths object
  * @param letterColor (string) - The color of the letter to be displayed inside the icon.
  * @param hasAdditionalInfo (boolean) - A flag stating if the seat has addional info attached to it (eg. restricted view)
  */
  function createSymbol(letter, letterColor, hasAdditionalInfo) {
    
    let id =  seatSymbolPrefix + letter
    if(hasAdditionalInfo) {
      id += starSeatSymbolSuffix
    }

    // Don't create the symbol if it already exists
    if(document.querySelector('#' + id)) return
    const symbol = document.createElementNS('http://www.w3.org/2000/svg', 'symbol')
    symbol.setAttribute('id', id)

    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
    circle.setAttribute('cx', 31)
    circle.setAttribute('cy', 41)
    circle.setAttribute('r', 29)

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    path.setAttribute('fill', letterColor)
    path.setAttribute('d', paths[letter])

    symbol.append(circle)
    symbol.append(path)

    // Adding the star to the symbol if there's additional info on the seat
    if(hasAdditionalInfo) {
      const shadow = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
      shadow.setAttribute('cx', 55)
      shadow.setAttribute('cy', 17)
      shadow.setAttribute('r', 16)
      shadow.setAttribute('fill', '#FFF')

      const background = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
      background.setAttribute('cx', 55)
      background.setAttribute('cy', 17)
      background.setAttribute('r', 14)
      background.setAttribute('fill', '#000')

      const star = document.createElementNS('http://www.w3.org/2000/svg', 'path')
      star.setAttribute('fill', '#FFF')
      star.setAttribute('d', 'M55 21.75l-5.584 2.936 1.066-6.218-4.517-4.404 6.243-.907L55 7.5l2.792 5.657 6.243.907-4.517 4.404 1.066 6.218z')

      symbol.append(shadow)
      symbol.append(background)
      symbol.append(star)
    }

    seatmapSVG.append(symbol)
  }

  /*
  * Goes over the available prices and the letters mapped to them
  * Calls the function creating the SVG symbols for each of the letters
  *
  * @param priceMap (object) - The object mapping prices to related colours and letters
  */
  function createPriceSymbols(priceMap) {
    Object.entries(priceMap).forEach(([key, value]) => {
      const letterColor = getLetterIconTextColor(value.color);

      // Create two variations of the symbol - with and without the star
      createSymbol(value.letter, letterColor, false)
      createSymbol(value.letter, letterColor, true)
    })
  }

  /*
  * Returns the last item in an array
  *
  * @param items (array) - An array of items
  */
  function last(items) {
    return items[items.length - 1]
  }

  /**
   * Determines the text color to use for the letter icon given the fill color.
   * 
   * @param {string} fillColor 
   * @returns {string} Hex color code
   */
  function getLetterIconTextColor(fillColor) {
    if (fillColor === '#FFED29') {
      return '#000';
    } 

    return '#FFF';
  }

  /*
  * Assigns each of the prices a letter and a colour
  *
  * @param prices (array) - an array of unique prices
  * @returns _map (object) - an object of prices mapped to related colours and letters
  */
  function getPriceMap(prices)
  {
    let _map = {}
    prices.sort((a,b)=>a-b).reverse().forEach((price, i) => {
      _map[price] = {
        color: colors[i],
        letter: letters[i]
      };
    })

    _map[last(prices)] = {
      color: last(colors),
      letter: last(letters)
    };

    // Get Into Dance Scheme, price of £3
    if (_map.hasOwnProperty(3)) {
      _map[3] = {
        color: '#FFED29',
        letter: undefined === _map[10] ? 'h' : 'i',
      };
    } 

    if ( _map.hasOwnProperty(3)) {
      const nextToLastPrice = prices[prices.length - 2] || null;

      if (nextToLastPrice !== null && ![3].includes(nextToLastPrice)) {
        // The next to last price
        _map[prices[prices.length - 2]] = {
          color: colors[colors.length - 1],
          letter: letters[letters.length - 1],
        };
      }
    }
    
    
    return _map
  }

  function isSeatAvailable(seat) {
    const status = (seat.seat_status_desc || '').toLowerCase();
    return status !== 'unavailable';
  }

  /*
  * Assigns a letter and colour to each available seat on the seatmap
  *
  * @returns seatData (object)
  */
  function getSeatMapData() {
    let seatData = {}
    seatmap.seats.forEach((seat) => {

      if (!isSeatAvailable(seat)) {
        return;
      }

      let price = zonePriceMap[seat.zone_no]
      
      if(price) {
        seatData[seat.seat_no] = {}
        seatData[seat.seat_no].color = priceMap[price].color
        seatData[seat.seat_no].letter = priceMap[price].letter
        seatData[seat.seat_no].hasAdditionalInfo = seat.GraphicType === "STAR"
        seatData[seat.seat_no].hasBarclaysDancePass = seat.zone_no === barclaysDancePassZoneID
      }
    })
    return seatData
  }

  /*
   * Applies the colours and new letters to the seatmap SVG
   *
   * @param seatData (object)
   * @returns boolean
   */
  function setSeatMapData(seatData) {

    const seats = document.querySelectorAll('.tn-syos-seat-map__seat');
    if (seats) {
      seats.forEach((seat) => {
        
        const currentSeatInfo = seatData[seat.dataset.tnSeatId];
        if (currentSeatInfo) {
          // Check if this seat is a wheelchair or companion seat using the aria-label
          const ariaLabel = seat.getAttribute('aria-label');
          const isWheelchairSeat = ariaLabel && ariaLabel.toLowerCase().includes('wheelchair');
          const isCompanionSeat = ariaLabel && ariaLabel.toLowerCase().includes('companion');

          if (isCompanionSeat) {
            seat.style.color = accessColor;
            seat.style.fill = accessColor;

            // Set the <use> element attributes for wheelchair seats
            let id = "#" + seatSymbolPrefix + "wc";
            if (currentSeatInfo.hasAdditionalInfo) {
              id += starSeatSymbolSuffix;
            }
            // This should point to the <use> element
            seat.children[0].setAttribute('xlink:href', id);
            // Putting this on the element as a fallback to use when (de)selecting seats
            seat.children[0].setAttribute('data-icon', id);

          } else if (isWheelchairSeat) {
            seat.style.color = accessColor;
            seat.style.fill = accessColor;

            // Set the <use> element attributes for wheelchair seats
            let id = "#" + seatSymbolPrefix + "w";
            if (currentSeatInfo.hasAdditionalInfo) {
              id += starSeatSymbolSuffix;
            }
            // This should point to the <use> element
            seat.children[0].setAttribute('xlink:href', id);
            // Putting this on the element as a fallback to use when (de)selecting seats
            seat.children[0].setAttribute('data-icon', id);

          } else if (currentSeatInfo.hasBarclaysDancePass) {
              seat.style.color = barclaysBlue;
              seat.style.fill = barclaysBlue;
        
              let id = "#" + seatSymbolPrefix + "h"; 
              if (currentSeatInfo.hasAdditionalInfo) {
                id += starSeatSymbolSuffix;
              }
        
              if (seat.children && seat.children[0]) {
                seat.children[0].setAttribute('xlink:href', id);
                seat.children[0].setAttribute('data-icon', id);
              }    
          } else {
            // Apply the regular processing for non-wheelchair and non-companion seats
            if (seat.style.color) {
              seat.style.color = currentSeatInfo.color;
              seat.style.fill = currentSeatInfo.color;

              if (currentSeatInfo.letter && seat.children) {
                let id = "#" + seatSymbolPrefix + currentSeatInfo.letter;
                if (currentSeatInfo.hasAdditionalInfo) {
                  id += starSeatSymbolSuffix;
                }
                // This should point to the <use> element
                seat.children[0].setAttribute('xlink:href', id);
                // Putting this on the element as a fallback to use when (de)selecting seats
                seat.children[0].setAttribute('data-icon', id);
              }
            }
          }
        }
      });
      return true;
    }
    return false;
  }

  /*
  * Helper method to create the Barclays Dance Pass icon (blue circle with white 'h')
  */
  function createBarclaysIcon(icon) {
    if (!icon) return;
  
    // Circle
    const circleElement = icon.querySelector('circle');
    if (circleElement) circleElement.setAttribute('fill', barclaysBlue);
  
    // Letter
    let legendLetter = icon.querySelector('path');
    if (!legendLetter) {
      legendLetter = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      icon.append(legendLetter);
    }
  
    legendLetter.setAttribute('fill', getLetterIconTextColor(barclaysBlue));
    legendLetter.setAttribute('d', paths['h']);
  }




  /*
  * Applies the colours and new letters to the seatmap legend
  *
  * @param prices (object) - The object mapping prices to related colours and letters
  */
  function setPriceLegend(prices, priceToZones) {
    // Remove any previously created Barclays Dance Pass clones
    document
      .querySelectorAll('.tn-syos-legend__description-group[tnew-bdp-clone="true"]')
      .forEach(group => group.remove());
  
    const groups = document.querySelectorAll('.tn-syos-legend__zone-list .tn-syos-legend__description-group');

    // Store the prices in descending order
    let _prices = Object.keys(prices).sort((a, b) => parseFloat(b) - parseFloat(a));

    // Loop through each group
    groups.forEach((zone, i) => {
      const labelElement = zone.querySelector('.tn-syos-legend__zone-label');
      const descriptionTerm = zone.querySelector('.tn-syos-legend__description-term');
      const icon = zone.querySelector("svg");
      const circle = icon.querySelector("circle");

      if (!labelElement || !descriptionTerm) return;

      // Only include Wheelchair and Companion sections if isloggedIn equals 15
      if (isloggedIn == 15) {
        if (labelElement.textContent.includes('Companion')) {
          labelElement.textContent = 'Wheelchair Companion Seat';
          // // Overwrite the color style with olive
          descriptionTerm.style.color = accessColor;
          let legendLetter = icon.querySelector("path");
          legendLetter.setAttribute('d', paths['wc']);
          return;
        } else if (labelElement.textContent.includes('Wheelchair')) {
          labelElement.textContent = 'Wheelchair Space';
          // // Overwrite the color style with olive
          descriptionTerm.style.color = accessColor;
          let legendLetter = icon.querySelector("path");
          legendLetter.setAttribute('d', paths['w']);
          return;
        }
      }
  
      if (i >= _prices.length) { 
        zone.remove(); 
        return; 
      }
  
      const priceKey = _prices[i];
      const price = parseFloat(priceKey).toFixed(2);
  
        if (icon) {
          // Ensure the letter is displayed correctly in the icon
          icon.setAttribute('aria-label', `Character ${prices[priceKey].letter.toUpperCase()} within a circle`);
          let legendLetter = icon.querySelector("path");
          if (!legendLetter) {
            legendLetter = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            icon.append(legendLetter);
          }
          legendLetter.setAttribute('fill', getLetterIconTextColor(prices[priceKey].color));
          legendLetter.setAttribute('d', paths[prices[priceKey].letter]);
        }
  
      // Add zones for each price as a data attribute to the group
      const zonesArray = priceToZones[priceKey] || [];
      const zones = zonesArray.map(String);
      zone.setAttribute('tnew-zone-ids', zones.join(','));

      // Barclays Dance Pass 
      const BDP_ID = String(barclaysDancePassZoneID);
      const hasBarclays = zones.includes(BDP_ID);
      const onlyBarclays = hasBarclays && zones.length === 1;
      
      if (onlyBarclays) {
        // If all zones for the price group are for the Barclays Dance Pass, restyle this group
        zone.classList.add('barclays-dance-pass');
        zone.setAttribute('tnew-zone-ids', BDP_ID);
        labelElement.innerHTML = `£${price}<span class="dance-pass">Barclays Dance Pass</span>`;
      
        // Apply Barclays styling
        createBarclaysIcon(icon);
        if (icon) {
          icon.setAttribute('aria-label', 'Character H within a circle');
        }

        return;

      } else if (hasBarclays && zones.length > 1) {
        // If there are multiple zones for the price group, including the Barclays Dance Pass duplicate the group
  
        // Keep the original group for all the non-Barclays Dance Pass zones
        const otherZones = zones.filter(id => id !== BDP_ID);
        zone.classList.remove('barclays-dance-pass');
        zone.setAttribute('tnew-zone-ids', otherZones.join(','));

        if (price == 3.00) {
          labelElement.innerHTML = `£${price}<span class="get-into-dance">Get Into Dance</span>`;
        } else {
          labelElement.textContent = `£${price}`;
        }
        descriptionTerm.style.color = prices[priceKey].color;
        circle.setAttribute("fill", prices[priceKey].color);
  
        // Clone the group for the Barclays Dance Pass zone
        const clone = zone.cloneNode(true);
        clone.classList.add('barclays-dance-pass');
        clone.setAttribute('tnew-bdp-clone', 'true');
        clone.setAttribute('tnew-zone-ids', BDP_ID);
        zone.after(clone);
      
        // Apply Barclays styling to the clone
        const cloneLabel = clone.querySelector('.tn-syos-legend__zone-label');
        const cloneIcon = clone.querySelector('svg');
  
        if (cloneLabel) {
          cloneLabel.innerHTML = `£${price}<span class="dance-pass">Barclays Dance Pass</span>`;
        }
        if (cloneIcon) {
          createBarclaysIcon(cloneIcon);
          cloneIcon.setAttribute('aria-label', 'Character H within a circle');
        }
        return;
      }
  
      // Price label
      if (price == 3.00) {
        labelElement.innerHTML = `£${price}<span class="get-into-dance">Get Into Dance</span>`;
      } else {
        labelElement.textContent = `£${price}`;
      }

      descriptionTerm.style.color = prices[priceKey].color;
      circle.setAttribute("fill", prices[priceKey].color);
    });
  }




  /*
  * An observer to look for changes on <use> elements (seats) within the seatmaps
  * It makes sure the icons stay consistent after users interact with them
  *
  * @param element (HTMLNode) element to observe
  */
 
  function setupSeatObserver(element) {
    const config = { childList: true, subtree: true, attributes: true };

    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        // If an attribute has changed on the <use> element within the seatmap
        if (mutation.target.nodeName === 'use' && mutation.type === 'attributes') {
          // Find the parent seat element
          const seatElement = mutation.target.closest('.tn-syos-seat-map__seat');

          // This is the current icon being used on the seat
          const href = mutation.target.getAttribute('xlink:href');

          // This is pointing to the icon assigned by us in the microzoning process
          const icon = mutation.target.dataset.icon;

          // If the href contains 'donut', the seat is selected. If not, it was just deselected
          if (!href.includes('donut') && href !== icon) {
            mutation.target.setAttribute('xlink:href', icon);
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(element, config);
  }



  /*
  * An observer to look for an addition of the modal inside the body
  * It makes sure the mobile legend is updated
  *
  * @param element (HTMLNode) element to observe
  */
  function setupSeatmapObserver(element) {
    const config = { childList: true }
    
    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        // If a modal has been added to the body and it contains the legend
        if (mutation.type === "childList" && element.querySelector(".tn-syos-legend__zone-list li")) {
          setPriceLegend(priceMap, priceToZones);
        }
      }
    }
    
    const observer = new MutationObserver(callback)
    observer.observe(element, config)
  }
    

  let uniquePrices = []
  let zonePriceMap = {}
  let priceToZones = {}

  seatmap.ScreenZoneList.forEach((zone) => {
    if (uniquePrices.indexOf(zone.default_price) == -1) {
      uniquePrices.push(zone.default_price)
    }
    zonePriceMap[zone.zone_no] = zone.default_price
  
    // Get all the zones per price
    const price = zone.default_price
    if (!priceToZones[price]) priceToZones[price] = []
    priceToZones[price].push(zone.zone_no)
  })

  // Detect Barclays Dance Pass zone dynamically from ZoneColorList
  if (seatmap.ZoneColorList && Array.isArray(seatmap.ZoneColorList)) {
    seatmap.ZoneColorList.forEach((zoneColor) => {
      const zoneLabel =
        zoneColor.zone_label ||
        zoneColor.ZoneLabel ||
        ''

      console.log('Checking ZoneColorList zone for Barclays Dance Pass:', zoneLabel)

      if (!barclaysDancePassZoneID && BARCLAYS_LABEL.test(zoneLabel)) {
        barclaysDancePassZoneID = zoneColor.zone_no
        console.log('Barclays Dance Pass zone detected:', barclaysDancePassZoneID)
      }
    })
  }
  
  let priceMap = getPriceMap(uniquePrices)

  
  if (setSeatMapData(getSeatMapData(zonePriceMap, priceMap))) {
    createPriceSymbols(priceMap)
    if (isloggedIn) {
      // Create separate symbols for Wheelchair and Wheelchair Companion
      createPriceSymbols([{letter: "w"}, {letter: "wc"}, {letter: "h"}])
    }
    setPriceLegend(priceMap, priceToZones)
    setupSeatObserver(seatmapSVG)
    setupSeatmapObserver(document.body);
  }
}

(function() {
  let oldXHROpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
    this.addEventListener('load', function() {
      let response = JSON.parse(this.responseText)
      console.log('XHR response received:', response);
      if (typeof response === 'object' && response !== null) {
        if ('ZoneColorList' in response && 'seats' in response) {
          setTimeout(function() {
            recolorSeatingPlan(response)
          }, 1)
        }
      }
    });
    return oldXHROpen.apply(this, arguments);
  }
})()
